/**
 * product-hero
 */
import '../../../../../apps/drupal/js/zoom-nvent.min';
// Module styles
import '../../01-atoms/tooltip/_tooltip.scss';
import './_product-hero.scss';

// Module template
import './_product-hero.twig';

export const name = 'product-hero';

export const defaults = {
  dummyClass: 'js-product-hero-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
(function ($, $context, productHero = {}) {
  // Find our component within the DOM
  const $productHero = $('.product-hero', $context);
  const $header = $('.header', $context);

  // Bail if component does not exist
  if (!$productHero.length) {
    return;
  }

  const prodHeroNarrativesReadMore = $(
    '.product_narratives__read-more',
    $context
  );
  const characterLimit = 250;
  const produtNarratives = $(
    '.product_narratives .product-hero__narratives--narrative'
  );
  let currentCharacterCount = 0;
  $.each(produtNarratives, function (i, listItem) {
    const $item = $(listItem);
    const itemCharacterCount = $item.text().length;
    if (currentCharacterCount + itemCharacterCount > characterLimit) {
      const remainingCharacters = characterLimit - currentCharacterCount;
      const truncatedContent = $item.text().substring(0, remainingCharacters);
      const remainingContent = $item.text().substring(remainingCharacters);
      prodHeroNarrativesReadMore.removeClass('visually-hidden');
      const remainingSpan = $('<span>')
        .addClass('remaining-characters')
        .text(remainingContent)
        .hide();
      $item
        .html(`${truncatedContent}<span class="ellipsis">...</span>`)
        .append(remainingSpan);
      remainingSpan.hide();
      for (let j = i + 1; j < produtNarratives.length; j++) {
        $(produtNarratives[j]).addClass('hide').hide();
      }
      return false; // Break out of the loop
    }
    currentCharacterCount += itemCharacterCount;
  });

  // Toggle hide/show on "Read more" click
  const readMoreLink = $('.product_narratives__read-more');
  readMoreLink.find('span.read-less').hide();
  let isExpanded = false;
  readMoreLink.on('click', function (event) {
    event.preventDefault();
    const ellipsisSpan = $('.ellipsis');
    const remainingSpan = $('.remaining-characters');
    const hiddenprodutNarratives = $(
      '.product_narratives .product-hero__narratives--narrative.hide'
    );
    if (!isExpanded) {
      hiddenprodutNarratives.show();
      remainingSpan.show();
      readMoreLink.find('span.read-less').show();
      readMoreLink.find('span.read-more').hide();
      ellipsisSpan.hide();
      readMoreLink.addClass('less');
    } else {
      hiddenprodutNarratives.hide();
      remainingSpan.hide();
      readMoreLink.find('span.read-less').hide();
      readMoreLink.find('span.read-more').show();
      ellipsisSpan.show();
      readMoreLink.removeClass('less');
    }
    isExpanded = !isExpanded;
  });

  const hasHiddenprodutNarratives =
    $('.product_narratives .product-hero__narratives--narrative.hide').length >
    0;
  const hasRemainingCharacters =
    $(
      '.product_narratives .product-hero__narratives--narrative span.remaining-characters'
    ).length > 0;

  // Hide the "Read More" button if there are no list items with the "hide" class
  if (!hasHiddenprodutNarratives && !hasRemainingCharacters) {
    readMoreLink.hide();
  }

  const $standards = $(
    '.product-hero__industry_standards--standards',
    $context
  );
  const $standardsReadMore = $(
    '.product-hero__industry_standards__read-more',
    $context
  );

  if ($standards.length > 10) {
    $standardsReadMore.removeClass('visually-hidden');
    $standardsReadMore.find('span.read-less').hide();
    $standards.slice(10).addClass('d-none');
  } else {
    $standardsReadMore.addClass('visually-hidden');
  }

  $standardsReadMore.on('click', (event) => {
    event.preventDefault();
    if ($standardsReadMore.hasClass('less')) {
      $standardsReadMore.removeClass('less');
      $standardsReadMore.find('span.read-more').show();
      $standardsReadMore.find('span.read-less').hide();
      $standards.slice(10).addClass('d-none');
    } else {
      $standardsReadMore.addClass('less');
      $standardsReadMore.find('span.read-more').hide();
      $standardsReadMore.find('span.read-less').show();
      $standards.removeClass('d-none');
    }
    return false;
  });

  if ($('.product-hero__image img').length) {
    // Merge defaults with incoming settings
    const settings = {
      ...defaults,
      ...productHero,
    };
    const url = $('.product-hero__image img').attr('src');
    const img = new Image();
    img.src = url; // Set the src of the Image object
    $productHero.addClass(settings.dummyClass);
    const zoomOptions = {
      zoomType: 'window',
      zoomWindowWidth: 600,
      zoomWindowHeight: window.innerWidth > 1400 ? 380 : 380,
      zoomWindowPosition: 1,
      zoomWindowOffetx: window.innerWidth > 1400 ? 50 : 50,
      zoomWindowOffety: -4,
      gallery: 'gallery_01',
      galleryActiveClass: 'active',
      easing: true,
      borderSize: 2,
      lensOpacity: 0.5,
      lensColour: '#d7d7d7',
      lensBorderColour: '#9a9b9c',
      lensSize: 100,
      borderColour: '#9a9b9c',
      cursor: 'crosshair',
      scrollZoom: true,
      scrollZoomIncrement: 0.5,
    };
    if ($(window).width() >= 1200 && img.width > 500) {
      $('.product-hero .product-hero__zoom img').elevateZoom(zoomOptions);
      $('.product-hero__enlarge').show();
    }
  }

  // Hides/shows modal
  const toggleDisplay = ($el, isOpen = false) => {
    switch (isOpen) {
      case true:
        $el.addClass('modal-open');
        $('body', $context).addClass('js-modal-is-open');
        break;
      default:
        $el.removeClass('modal-open');
        $('body', $context).removeClass('js-modal-is-open');
        break;
    }
  };

  const initModal = ($modal) => {
    $modal.on('click', '.product-hero__image .trigger-open', () => {
      toggleDisplay($modal, true);
    });

    $modal.on('click', '.trigger-close', () => {
      toggleDisplay($modal, false);
    });
  };
  $(window).on('click', (e) => {
    if ($(e.target).is('.overlay')) {
      toggleDisplay($productHero, false);
    }
  });
  $(document).on('click', '.zoomContainer', function () {
    $('.product-hero__image .trigger-open').trigger('click');
  });
  $productHero.each((i, el) => {
    initModal($(el));
  });

  //  Add the headerHeight to the gallery for sticky
  $(window)
    .on('resize', () => {
      if ($(window).width() >= 720) {
        $('.product-hero__zoom').css({
          top: $header.outerHeight(),
        });
      } else {
        $('.product-hero__zoom').css({
          top: 0,
        });
      }
    })
    .trigger('resize');
})(jQuery);
